var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap",
      staticStyle: { width: "600px", height: "600px", "overflow-y": "hidden" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(" close ")]
      ),
      _c(
        "div",
        { staticClass: "popup_cont" },
        [
          _c("e-breadcrumbs"),
          _c("div", { staticClass: "content_box mt10" }, [
            _c("div", { staticClass: "flex_box" }, [
              _c(
                "span",
                {
                  staticStyle: {
                    width: "90%",
                    float: "left",
                    color: "#075bb9",
                    "font-weight": "500",
                    "font-size": "17px",
                    "margin-left": "10px",
                  },
                },
                [
                  _vm._v("R/A (S/C) No : " + _vm._s(_vm.raNo) + " "),
                  _c(
                    "span",
                    { staticStyle: { "font-size": "15px", color: "red" } },
                    [_vm._v(" " + _vm._s(_vm.negoAfterText) + " ")]
                  ),
                ]
              ),
            ]),
            _c("table", { staticClass: "tbl_search" }, [
              _vm._m(0),
              _c("tbody", [
                _vm._m(1),
                _c("tr", [
                  _c("th", [_vm._v("POR (국가)")]),
                  _c("td", { attrs: { colspan: "4" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.porPlcNm,
                          expression: "porPlcNm",
                        },
                      ],
                      attrs: { type: "text", id: "porPlcNm", readonly: "" },
                      domProps: { value: _vm.porPlcNm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.porPlcNm = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("td", { attrs: { colspan: "4" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.porCtrNm,
                          expression: "porCtrNm",
                        },
                      ],
                      attrs: { type: "text", id: "porCtrNm", readonly: "" },
                      domProps: { value: _vm.porCtrNm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.porCtrNm = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
                _c("tr", [
                  _c("th", [_vm._v("DLY (국가)")]),
                  _c("td", { attrs: { colspan: "4" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.dlyPlcNm,
                          expression: "dlyPlcNm",
                        },
                      ],
                      attrs: { type: "text", id: "dlyPlcNm", readonly: "" },
                      domProps: { value: _vm.dlyPlcNm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.dlyPlcNm = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("td", { attrs: { colspan: "4" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.dlyCtrNm,
                          expression: "dlyCtrNm",
                        },
                      ],
                      attrs: { type: "text", id: "dlyCtrNm", readonly: "" },
                      domProps: { value: _vm.dlyCtrNm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.dlyCtrNm = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
                _c("tr", [
                  _c("th", [_vm._v("운임유효기간")]),
                  _c("td", { attrs: { colspan: "4" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.freExpDate,
                          expression: "freExpDate",
                        },
                      ],
                      attrs: { type: "text", id: "freExpDate", readonly: "" },
                      domProps: { value: _vm.freExpDate },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.freExpDate = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
                _c("br"),
                _vm._m(2),
                _c("br"),
                _c("tr", [
                  _c("th", [_vm._v("실화주")]),
                  _c("td", { attrs: { colspan: "5" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.actShpNm,
                          expression: "actShpNm",
                        },
                      ],
                      attrs: { type: "text", id: "actShpNm" },
                      domProps: { value: _vm.actShpNm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.actShpNm = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
                _c("tr", [
                  _c("th", [_vm._v("IDEAL RATE")]),
                  _c("th", { attrs: { colspan: "2" } }, [_vm._v("20FT (USD)")]),
                  _c(
                    "td",
                    { attrs: { colspan: "3" } },
                    [
                      _c("e-input-number", {
                        attrs: { id: "req20Ft" },
                        model: {
                          value: _vm.req20Ft,
                          callback: function ($$v) {
                            _vm.req20Ft = $$v
                          },
                          expression: "req20Ft",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("tr", [
                  _c("th"),
                  _c("th", { attrs: { colspan: "2" } }, [_vm._v("40FT (USD)")]),
                  _c(
                    "td",
                    { attrs: { colspan: "3" } },
                    [
                      _c("e-input-number", {
                        attrs: { id: "req40Ft" },
                        model: {
                          value: _vm.req40Ft,
                          callback: function ($$v) {
                            _vm.req40Ft = $$v
                          },
                          expression: "req40Ft",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._m(3),
                _c("tr", [
                  _c("th"),
                  _c("td", { attrs: { colspan: "6" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lssYn,
                          expression: "lssYn",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "lssYn",
                        name: "lssYn",
                        "true-value": "Y",
                        "false-value": "N",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.lssYn)
                          ? _vm._i(_vm.lssYn, null) > -1
                          : _vm._q(_vm.lssYn, "Y"),
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.lssYn,
                            $$el = $event.target,
                            $$c = $$el.checked ? "Y" : "N"
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.lssYn = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.lssYn = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.lssYn = $$c
                          }
                        },
                      },
                    }),
                    _vm._m(4),
                    _c("br"),
                  ]),
                ]),
                _vm._m(5),
                _vm._m(6),
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "text_right", attrs: { colspan: "7" } },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "button blue sh",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.kmtcOnNegoRequest()
                            },
                          },
                        },
                        [_vm._v("KMTC ON NOW 운임 협의하기")]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("br"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "100px" } }),
      _c("col", { attrs: { width: "50px" } }),
      _c("col", { attrs: { width: "50px" } }),
      _c("col", { attrs: { width: "50px" } }),
      _c("col", { attrs: { width: "50px" } }),
      _c("col", { attrs: { width: "100px" } }),
      _c("col", { attrs: { width: "100px" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [_c("th")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "10" } }, [
        _c("div", { staticStyle: { "font-size": "16px" } }, [
          _vm._v(" KMTC ON NOW를 이용해서 운임을 협의해보세요."),
          _c("br"),
          _vm._v(
            " 하기 정보를 입력해주시면 즉시 협의된 운임을 확인하실 수 있습니다."
          ),
          _c("br"),
          _c("br"),
          _vm._v(" (요청해주신 IDEAL RATE 수준에 따라 "),
          _c("br"),
          _vm._v(
            "  원하시는 협의 운임이 도출되지 않을 수 있는 점 양해 부탁드립니다.) "
          ),
          _c("br"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [_c("th")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "mr10", attrs: { for: "lssYn" } }, [
      _c("span"),
      _vm._v("선적지 LSS 포함 기준으로 IDEAL RATE를 제출하겠습니다.(선택)"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [_c("th"), _c("td")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [_c("th"), _c("td")])
  },
]
render._withStripped = true

export { render, staticRenderFns }